import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';

const AudioSettings = ({ 
  settings, 
  onSettingsChange, 
  disabled = false 
}) => {
  const inputDeviceOptions = [
    { value: 'default', label: 'Системный микрофон по умолчанию' },
    { value: 'usb-mic', label: 'USB микрофон (Blue Yeti)' },
    { value: 'headset', label: 'Гарнитура (Sony WH-1000XM4)' },
    { value: 'interface', label: 'Аудиоинтерфейс (Focusrite Scarlett)' }
  ];

  const bitrateOptions = [
    { value: '64', label: '64 kbps (Низкое качество)' },
    { value: '128', label: '128 kbps (Среднее качество)' },
    { value: '192', label: '192 kbps (Высокое качество)' },
    { value: '320', label: '320 kbps (Максимальное качество)' }
  ];

  const handleChange = (field, value) => {
    onSettingsChange({
      ...settings,
      [field]: value
    });
  };

  return (
    <div className="audio-settings bg-card rounded-lg border border-border p-6 shadow-soft">
      <div className="settings-header mb-4">
        <div className="flex items-center gap-2 mb-1">
          <Icon name="Settings" size={20} color="var(--color-foreground)" />
          <h3 className="text-lg font-heading font-semibold text-foreground">
            Настройки аудио
          </h3>
        </div>
        <p className="text-sm text-muted-foreground">
          Настройте параметры записи и трансляции
        </p>
      </div>
      <div className="settings-form space-y-4">
        <Select
          label="Устройство ввода"
          options={inputDeviceOptions}
          value={settings?.inputDevice || 'default'}
          onChange={(value) => handleChange('inputDevice', value)}
          disabled={disabled}
        />

        <Select
          label="Битрейт"
          description="Более высокий битрейт = лучшее качество, но больше трафика"
          options={bitrateOptions}
          value={settings?.bitrate || '192'}
          onChange={(value) => handleChange('bitrate', value)}
          disabled={disabled}
        />

        <div className="settings-toggles space-y-3 pt-2">
          <Checkbox
            label="Шумоподавление"
            description="Автоматическое удаление фонового шума"
            checked={settings?.noiseSuppression || true}
            onChange={(e) => handleChange('noiseSuppression', e?.target?.checked)}
            disabled={disabled}
          />

          <Checkbox
            label="Эхоподавление"
            description="Устранение эха и обратной связи"
            checked={settings?.echoCancellation || true}
            onChange={(e) => handleChange('echoCancellation', e?.target?.checked)}
            disabled={disabled}
          />

          <Checkbox
            label="Автоматическая регулировка усиления"
            description="AGC для стабильного уровня громкости"
            checked={settings?.autoGainControl || true}
            onChange={(e) => handleChange('autoGainControl', e?.target?.checked)}
            disabled={disabled}
          />

          <Checkbox
            label="Мониторинг в реальном времени"
            description="Слышать себя во время записи"
            checked={settings?.monitoring || false}
            onChange={(e) => handleChange('monitoring', e?.target?.checked)}
            disabled={disabled}
          />
        </div>

        <div className="settings-info mt-4 p-3 bg-muted rounded-lg">
          <div className="flex items-start gap-2">
            <Icon name="Info" size={16} color="var(--color-muted-foreground)" className="mt-0.5" />
            <p className="text-xs text-muted-foreground">
              Рекомендуем использовать наушники для предотвращения обратной связи и качественный микрофон для лучшего звука.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AudioSettings;